import { FormData } from '../../pages/policy/policy'
import { BASE_URL } from '../endpoints'
import { del, get, patch, post } from '../https'

export const getAllPolicies = (
  sortBy: string,
  sortOrderValue: string,
  data: string[]
): Promise<unknown> => {
  const schoolsQuery = data
    ?.map((school) => `schools[]=${encodeURIComponent(school)}`)
    .join('&')
  return get(
    `${BASE_URL}/policies?sortBy=${sortBy}&sortOrder=${sortOrderValue}&${schoolsQuery}`
  )
}

export const getAllPolicyById = (
  id: string | null,
  schoolId: string | null
): Promise<unknown> => {
  console.log('schoolId', schoolId)
  return get(`${BASE_URL}/policies/${id}?school=${schoolId}`, null)
}
export const createPolicy = (data: FormData): Promise<unknown> => {
  return post(`${BASE_URL}/policies`, data, null)
}

export const updatePolicy = (
  data: FormData,
  id: string | null
): Promise<unknown> => {
  return patch(`${BASE_URL}/policies/${id}`, data, null)
}

export const deletePolicy = ({
  id,
}: {
  id: string | undefined | null
}): Promise<unknown> => {
  return del(`${BASE_URL}/policies/${id}`, null)
}

export const updatePolicyStatus = (
  data: {
    status: string
  },
  id: string | null
): Promise<unknown> => {
  return patch(`${BASE_URL}/policies/${id}/change-status`, data, null)
}
